// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tooltip-banking-rate-info .tooltip-inner{max-width:unset;border:1px solid #166987}#tooltip-banking-rate-info.tooltip.b-tooltip-light.bs-tooltip-bottom .arrow:before{border-bottom-color:#166987}", ""]);
// Exports
module.exports = exports;
